export const ACTIONTYPES = {
  SAVE: 'SAVE',
  UPDATE: 'UPDATE',
  CLONE: 'CLONE',
  DEFAULT: 'DEFAULT',
} as const;

export type ClickType = 'SAVE' | 'UPDATE' | 'CLONE' | 'DEFAULT';
